import { Link } from "react-router-dom";
import { Phone, Mail, Globe, Linkedin, Instagram } from "lucide-react";
import { motion } from "framer-motion";

export default function Footer() {
  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 },
    },
  };

  return (
    <footer className="bg-gray-800 text-white py-12">
      <div className="container mx-auto px-4">
        <motion.div
          className="grid grid-cols-1 md:grid-cols-3 gap-8"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          <motion.div variants={fadeIn}>
            <div className="flex items-center">
              <Link className="flex items-center cursor-pointer">
                <img
                  src="/logo-no-bg.png"
                  alt="Logo"
                  className="h-7 w-auto object-contain"
                />
              </Link>
            </div>
            <p className="text-gray-400 mb-4 mt-4">
              Comprehensive school management software solutions for educational
              institutions of all sizes.
            </p>
            <div className="flex space-x-4 pt-2">
              <motion.a
                href="https://www.linkedin.com/company/clynox/posts/?feedView=all"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="bg-blue-800 p-2 rounded-full text-white hover:bg-blue-700"
                whileHover={{ scale: 1.2, rotate: 5 }}
                whileTap={{ scale: 0.9 }}
              >
                <Linkedin className="h-5 w-5" />
              </motion.a>
              <motion.a
                href="https://www.instagram.com/clynox_solutions/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="bg-gradient-to-br from-purple-600 via-pink-600 to-orange-500 p-2 rounded-full text-white hover:from-purple-500 hover:via-pink-500 hover:to-orange-400"
                whileHover={{ scale: 1.2, rotate: 5 }}
                whileTap={{ scale: 0.9 }}
              >
                <Instagram className="h-5 w-5" />
              </motion.a>
            </div>
          </motion.div>

          <motion.div variants={fadeIn}>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <motion.li
                className="flex items-start"
                whileHover={{ x: 5, transition: { duration: 0.2 } }}
              >
                <Phone className="h-5 w-5 text-blue-400 mr-2 flex-shrink-0 mt-0.5" />
                <a
                  href="tel:+917499070944"
                  className="text-gray-400 hover:text-blue-400"
                >
                  +91-7499070944
                </a>
              </motion.li>

              <motion.li
                className="flex items-start"
                whileHover={{ x: 5, transition: { duration: 0.2 } }}
              >
                <Mail className="h-5 w-5 text-blue-400 mr-2 flex-shrink-0 mt-0.5" />
                <a
                  href="mailto:clynoxofficial@gmail.com"
                  className="text-gray-400 hover:text-blue-400"
                >
                  clynoxofficial@gmail.com
                </a>
              </motion.li>

              <motion.li
                className="flex items-start"
                whileHover={{ x: 5, transition: { duration: 0.2 } }}
              >
                <Globe className="h-5 w-5 text-blue-400 mr-2 flex-shrink-0 mt-0.5" />
                <span className="text-gray-400">www.clynox.com</span>
              </motion.li>
            </ul>
          </motion.div>

          <motion.div variants={fadeIn}>
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-3">
              <motion.li whileHover={{ x: 5, transition: { duration: 0.2 } }}>
                <Link
                  to="/privacy-policy"
                  className="text-gray-400 hover:text-blue-400"
                >
                  Privacy Policy
                </Link>
              </motion.li>
              <motion.li whileHover={{ x: 5, transition: { duration: 0.2 } }}>
                <Link
                  to="/terms-conditions"
                  className="text-gray-400 hover:text-blue-400"
                >
                  Terms & Conditions
                </Link>
              </motion.li>
              <motion.li whileHover={{ x: 5, transition: { duration: 0.2 } }}>
                <Link
                  to="/refund-policy"
                  className="text-gray-400 hover:text-blue-400"
                >
                  Refund Policy
                </Link>
              </motion.li>
            </ul>
          </motion.div>
        </motion.div>

        <div className="border-t border-gray-700 mt-10 pt-6 text-center text-gray-400">
          <p>© {new Date().getFullYear()} All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
